import request from '../../utils/request'
// const baseURL = 'https://www.xjiajiao.com/jiazheng'
// const baseURL = 'https://food.yylx8.vip'
import config from '../../config/config'
const baseURL = config.baseURL
// 注册
export function register (data) {
  return request({
    url: baseURL + '/api/user/add',
    method: 'post',
    data: data
  })
}
export function login (data) {
  return request({
    url: baseURL + '/api/auth/login',
    method: 'post',
    data: data
  })
}
export function teacherInfo (data) {
  return request({
    url: baseURL + '/api/users/userid',
    method: 'post',
    data: data
  })
}
export function shenUpdate (data) {
  return request({
    url: baseURL + '/api/users/shenUpdate',
    method: 'post',
    data: data
  })
}





// 获取产品列表
export function getProdList (query) {
  return request({
    url: baseURL + '/product/list/prodName',
    method: 'get',
    params: query
  })
}

// 根据id 查看商品详情
export function getProdetail (query) {
  return request({
    url: baseURL + '/product/detail/id',
    method: 'get',
    params: query
  })
}

// 修改商品
export function updateProduct (data) {
  return request({
    url: baseURL + '/product/info/update',
    method: 'put',
    data: data
  })
}

// 修改值班分组人员
export function addProduct (data) {
  return request({
    url: baseURL + '/product/info/add',
    method: 'post',
    data: data
  })
}

// 删除班组
export function deleletProdcut (query) {
  return request({
    url: baseURL + '/product/info/delete',
    method: 'delete',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/user/user.js